import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import classnames from 'classnames';

import { actions } from '../../../../components/UIContainer/MobileUI/MainShell/actions/actions';
import { go } from '../../../../routes';
import { ReactComponent as Logo } from '../../../../svgs/logo.svg';
import { ReactComponent as Arrow } from '../../../../svgs/leftarrow.svg';
import MobileMenu from '../MobileMenu/index';
import { profilePropType } from '../../../../components/UIContainer/MobileUI/MainShell/propTypes';
import styles from './mobileHeader.module.css';

class MobileHeader extends Component {
  static propTypes = {
    id: PropTypes.string,
    practice: PropTypes.string,
    page: PropTypes.object,
    logout: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    setComponentIndex: PropTypes.func.isRequired,
    goToHome: PropTypes.func.isRequired,
    goToPractices: PropTypes.func.isRequired,
    goToDependants: PropTypes.func.isRequired,
    profile: profilePropType,
  };
  state = {
    scrolled: false,
    menuOpen: false,
  };
  componentDidMount() {
    window.addEventListener('scroll', this.checkScroll, true);
  }
  shouldComponentUpdate = (nextProps, nextState) =>
    nextState !== this.state || nextProps.isLoggedIn !== this.props.isLoggedIn;
  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkScroll, true);
  }
  checkScroll = () => {
    if (this.props.page?.getBoundingClientRect().top <= -190) {
      this.setState({ scrolled: true });
    } else if (this.state.scrolled) this.setState({ scrolled: false });
  };
  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };
  changePage = index => () => {
    this.props.setComponentIndex(index);
    this.props.goToHome();
  };
  logout = () => {
    this.props.logout();
    this.toggleMenu();
  };
  render() {
    return (
      <div>
        <div
          className={classnames(
            styles.container,
            { [styles.scrolled]: this.state.scrolled },
            { [styles.open]: this.state.menuOpen },
          )}
        >
          <div onClick={this.toggleMenu}>
            <Logo className={this.state.menuOpen ? styles.logoOpen : this.state.scrolled ? styles.logoScrolled : styles.logo} />
            <Arrow className={styles.arrow} />
          </div>
        </div>
        <MobileMenu
          id={this.props.id}
          open={this.state.menuOpen}
          profile={this.props.profile}
          practice={this.props.practice}
          isLoggedIn={this.props.isLoggedIn}
          logout={this.logout}
          changePage={this.changePage}
          goPractices={this.props.goToPractices}
          goDependants={this.props.goToDependants}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.editProfileReducer,
});

const mapDispatchToProps = dispatch => ({
  goToHome: () => go.home(),
  // eslint-disable-next-line max-len
  goToPractices: () => go.practices(),
  goToDependants: () => go.dependants(),
  setComponentIndex: bindActionCreators(actions.setComponentIndex, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileHeader);
